<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
  >
    <v-card>
      <v-card-title>
        {{ title }}
        
      </v-card-title>
      <v-card-text class="pt-5">

        <p class="text-muted">{{ productObject ? productObject.name : '' }} isimli ürün için düzenleme yapıyorsunuz</p>
        <v-text-field
          v-model="productObject.codes"
          filled
          solo
          dense
          placeholder="Muadil Kod"
          persistent-hint
          hint="Birden fazla muadil kod eklemek için araya virgül koyunuz"
        >

        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="dialog = false">
          İptal
        </v-btn>
        
        <v-btn text color="primary" @click="addOrUpdateEquivalentCode">
          Kaydet
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { mapActions,mapState } from "vuex";

export default {
  props:{
    showDialog:{
      type:Boolean,
      default:false
    },
    title:{
      type: String,
      default: ""
    },
    product:{

    }
  },
  computed:{
    ...mapState("stock",['equivalentCodeList'])
  },
  data(){
    return {
      dialog: false,
      productObject:{}
    }
    
  },
  methods: {
    ...mapActions("stock",['fetchEquivalentCodeList','equivalentCodeAdd','equivalentCodeUpdate']),
    async getEquivalentCodeList(){
      await this.fetchEquivalentCodeList({
        params:{
          pageNumber: 1,
          condition: this.productObject.code
        },
        body:{
        }
      })
    },
    async addOrUpdateEquivalentCode(){
      if(this.product.codes === "" || this.product.codes === null){
       await this.equivalentCodeAdd({
          params:{

          },
          body:{
            "StockCode": this.productObject.code,
            "Codes": this.productObject.codes
          }
        })


      }
      else {
         await this.equivalentCodeUpdate({
          params:{

          },
          body:{
            "Id": this.equivalentCodeList[0].id,
            "StockCode": this.productObject.code,
            "Codes": this.productObject.codes
          }
        })
      }
      this.dialog = false
    }
  },
  watch:{
    "dialog": function (newVal){
      this.$emit("dialogChange",newVal)

    },
    "showDialog": function (newVal){
      this.dialog = newVal
    },
    "product": function (newVal) {
      this.productObject = Object.assign({},newVal);
      if(newVal)
        this.getEquivalentCodeList()
    }

  }
}

</script>